<template>
  <v-row no-gutters>
    <v-col cols="12">
      <div v-for="(vehicle, index) in vehicles" :key="index">
        <div class="list-item">
          <v-btn
            class="list-item-btn"
            :ripple="false"
            block
            color="white"
            @click.stop="(showDialog = true), (vehicleToUpdate = vehicle)"
          >
            <div class="list-item-text">
              <span class="list-item-name">{{ vehicleListName(vehicle) }}</span>
            </div>
          </v-btn>
        </div>
      </div>
      <div class="mt-5 mb-5">
        <AlternativeButton
          :title="'Add Vehicle'"
          @gradientButtonClicked="addVehicleClicked"
        />
      </div>
    </v-col>
    <VehicleDialog v-model="showDialog" :vehicle-to-update="vehicleToUpdate" />
  </v-row>
</template>

<script>
  import VehicleDialog from './VehicleDialog.vue';

  export default {
    name: 'VehiclesList',
    components: {
      VehicleDialog,
    },
    props: {
      vehicles: {
        required: true,
        type: Array,
      },
    },
    data() {
      return {
        showDialog: false,
        vehicleToUpdate: {},
      };
    },
    methods: {
      addVehicleClicked() {
        this.vehicleToUpdate = {};
        this.showDialog = true;
        this.sendGADataLayer('add-vehicle');
      },
      sendGADataLayer(event) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: event,
          omuserid: this.$store.getters?.userId,
        });
      },
      vehicleListName(vehicle) {
        return vehicle.color + ' ' + vehicle.make + ' ' + vehicle.model;
      },
    },
  };
</script>

<style scoped lang="scss"></style>
